import { Fragment, forwardRef } from "react";
import { Draggable, Droppable } from "react-beautiful-dnd";
import addParagraph from "../../../assets/images/model/add_paragraph.svg";
import dragDrop from "../../../assets/images/model/drag_drop.svg";
import { useLocation, useParams } from "react-router-dom";
import dimond from "../../../assets/images/greyled-activity.svg";
import OutlineElement from "../../../components/OutlineElement";
import MediaComponent from "../../../components/createmode/MediaComponent";
import BlockComponent from "../../../components/BlockComponent";

const Section = forwardRef(({ ...props }, ref) => {
  function getStyle(style, snapshot) {
    if (!snapshot.isDropAnimating) {
      return style;
    }
    const { moveTo, curve, duration } = snapshot.dropAnimation;
    // move to the right s  // add a bit of turn for fun
    const translate = `translate(${moveTo.x}px, ${moveTo.y}px)`;

    return {
      ...style,
      transform: `${translate}`,
      transition: `all ${curve} ${duration + 0.2}s`
    };
  }
  return (
    <Draggable
      draggableId={`sections_${props.chapInd}_${props.secIndex}`}
      index={props.secIndex}>
      {(provided, snapshot) => (
        <div
          key={props.secIndex}
          id={`${props.chap._id}.${props.section._id}`}
          data-id={`${props.section._id}`}
          data-secid={props.chap._id}
          className={props.dynamicSectionStyles(props.chap, props.section)}
          onDragOver={(e) => {
            props.handleDragOver(
              e,
              props.section._id,
              props.chap._id,
              props.section._id,
              "",
              "section"
            );
          }}
          onDragLeave={props.handleDragLeave}
          onDrop={(e) => {
            props.handleSectionDrop(
              e,
              props.chap,
              props.chapInd,
              props.section,
              props.secIndex
            );
          }}
          ref={provided.innerRef}
          {...provided.draggableProps}
          isDragging={snapshot.isDragging && !snapshot.isDropAnimating}
          style={getStyle(provided.draggableProps.style, snapshot)}>
          <div ref={ref} data-section-order={props?.section?.order}>
            <div className="parent_subtitle px-1">
              <div className="create_subtitle">
                <img
                  style={{
                    marginRight: "0.5rem",
                    cursor: "pointer"
                  }}
                  src={addParagraph}
                  alt=" section paragraph"
                  onClick={() => {
                    props.setShowBlock(props.section._id);
                  }}
                />
                <img
                  src={dragDrop}
                  alt=""
                  style={{
                    cursor: "grab"
                  }}
                  {...provided.dragHandleProps}
                />
              </div>

              {props.showBlock === props.section._id && (
                <BlockComponent
                  {...props}
                  setShowBlock={props.setShowBlock}
                  handleChapterDelete={props.handleChapterDelete}
                  blockId={props.section._id} // section ID
                  blockType="section" // Specify it's a section
                  sectionIndex={props.secIndex}
                  blockIndex={props.secIndex} // section index
                  chapIndex={props.chapInd} // chapter index
                />
              )}
              <div className="main-text">
                <h5
                  className={`mb-0 w-95 editable-element ${
                    props.book.activities.findIndex(
                      (e) => e.section === props.section._id
                    ) > -1
                      ? "rich"
                      : ""
                  }`} // contentEditable={true}
                  onClick={(e) =>
                    props.setEditableElement(e, {
                      parentElement: "section",
                      elementId: props.section._id,
                      field: "title",
                      chapInd: props.chapInd,
                      secInd: props.secIndex
                    })
                  }
                  dangerouslySetInnerHTML={{
                    __html: props.section.title
                  }}></h5>
                {props?.draggedOverElement === props.section._id &&
                  (props.draggedType === "paragraph" ||
                    props.draggedType === "small_header") && (
                    <div // className="dragged_indicator"
                      style={{
                        height: 0
                      }}
                      id="dragged_indicator"></div>
                  )}
                <div
                  className={
                    props?.draggedOverElement === props.section._id &&
                    (props?.draggedType === "paragraph" ||
                      props.draggedType === "small_header")
                      ? "dragged_indicator"
                      : "dragged_indicator_transparent"
                  }
                  id="indicator"></div>
              </div>
              {props.book.activities.findIndex(
                (e) =>
                  e.sections?.includes(props.section?._id) &&
                  (e?.sections?.length === 1 ||
                    e?.sections?.indexOf(props.section?._id) === 0)
              ) > -1 && (
                <img
                  src={dimond}
                  alt="diamond"
                  className="cursor"
                  onClick={(e) => {
                    props.setHighlightedParagraph(null);
                    props.setGreyedPharagraphs([]);
                    props.setHighlightedIndexes([]);
                    props.setDraggedOver(null);
                    props.highlightSection(e, `${props.section._id}`);
                  }}
                />
              )}
            </div>

            <Droppable
              droppableId={`paragraphs_${props.chapInd}_${props.secIndex}`}
              type="paragraph">
              {(provided) => (
                <div
                  style={{
                    position: "relative",
                    minHeight: "30px"
                  }}
                  {...provided.droppableProps}
                  ref={provided.innerRef}>
                  {props.highlightedIndexes.length > 0 &&
                  props.draggedChap ===
                    `${props.chap._id}.${props.section._id}` &&
                  !props?.isSections ? (
                    <OutlineElement
                      top={props.pTop}
                      height={props.outlineHeight}
                      resizingSet={props.resizingSet}
                      isResizing={props.isResizing}
                      isErrored={props.isErrored}
                    />
                  ) : (
                    ""
                  )}
                  {props.section.paragraphs.map((paragraph, index) => (
                    <Draggable
                      key={`paragraph_${props.chapInd}_${props.secIndex}_${index}`}
                      draggableId={`paragraph_${props.chapInd}_${props.secIndex}_${index}`}
                      index={index}>
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}>
                          <>
                            {(paragraph?.text ||
                              (paragraph?.type === "paragraph" &&
                                paragraph?.media.length > 0)) && (
                              <div
                                className={`${
                                  props.draggedOver &&
                                  props.draggedOver.type === "paragraph" &&
                                  props.draggedOver.index ===
                                    `${props.chap._id}.${props.section._id}.${paragraph._id}`
                                    ? "trigger"
                                    : ""
                                } main-pera-wraper unique_paragraph ${
                                  props.isResizing ? "resizing" : ""
                                } ${
                                  props.greyedParagraphs.includes(paragraph._id)
                                    ? "bg_grey"
                                    : ""
                                } ${
                                  props.highlightedIndexes.includes(
                                    props.chap._id +
                                      "." +
                                      props.section._id +
                                      "." +
                                      paragraph._id
                                  )
                                    ? "activated_p_tags"
                                    : ""
                                }`}
                                style={{
                                  margin: `${
                                    props.highlightedParagraph ===
                                      paragraph._id ||
                                    props.greyedParagraphs.includes(
                                      paragraph._id
                                    )
                                      ? "0px 0px"
                                      : ""
                                  }`
                                }}
                                data-id={paragraph._id}
                                data-secid={props.section._id}
                                id={`${props.chap._id}.${props.section._id}.${paragraph._id}`}
                                onDrop={(e) => {
                                  props.handleParagraphDrop(
                                    e,
                                    props.chap,
                                    props.chapInd,
                                    props.section,
                                    props.secIndex,
                                    paragraph,
                                    index
                                  );
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                onDragOver={(e) => {
                                  props.handleDragOver(
                                    e,
                                    paragraph._id,
                                    props.chap._id,
                                    props.section._id,
                                    paragraph._id,
                                    "paragraph"
                                  );
                                }}>
                                <div className="parent_subtitle ">
                                  <div className="create_subtitle">
                                    <img
                                      style={{
                                        marginRight: "0.5rem",
                                        cursor: "pointer"
                                      }}
                                      src={addParagraph}
                                      onClick={() => {
                                        props.setShowBlock(paragraph._id);
                                      }}
                                      alt="plus"
                                    />
                                    <img
                                      src={dragDrop}
                                      alt=""
                                      style={{
                                        cursor: "grab"
                                      }}
                                      {...provided.dragHandleProps}
                                    />
                                  </div>
                                  <div className="d-flex justify-content-between w-100">
                                    {props.showBlock === paragraph._id && (
                                      <BlockComponent
                                        {...props}
                                        paragraphObj={paragraph}
                                        blockId={paragraph._id} // paragraph ID
                                        blockType="paragraph" // Specify it's a paragraph
                                        sectionIndex={props.secIndex}
                                        paragraphsIndex={index}
                                        blockIndex={index} // paragraph index
                                        chapIndex={props.chapInd} // chapter index (if applicable)
                                      />
                                    )}

                                    <div className="main-text">
                                      <div
                                        className={props.dynamicPStyles(
                                          props.chap,
                                          props.section,
                                          paragraph
                                        )}
                                        data-id={`${props.chap._id}.${props.section._id}.${paragraph._id}`}
                                        key={index}
                                        style={{
                                          position: "relative"
                                        }}>
                                        <div
                                          className="editable-element" // contentEditable={true}
                                          onClick={(e) =>
                                            props.setEditableElement(e, {
                                              parentElement: "paragraph",
                                              elementId: paragraph._id,
                                              field: "text",
                                              chapInd: props.chapInd,
                                              secInd: props.secIndex,
                                              parInd: index
                                            })
                                          }
                                          dangerouslySetInnerHTML={{
                                            __html:
                                              paragraph.text ||
                                              (paragraph?.media?.length === 0
                                                ? "Add text to the paragraph"
                                                : "")
                                          }}></div>

                                        {paragraph.media && (
                                          <>
                                            {paragraph.media.map(
                                              (media, mIndex) => (
                                                <MediaComponent
                                                  chapterIndex={props.chapInd}
                                                  secInd={props.secIndex}
                                                  pIndex={index}
                                                  setBook={props.setBook}
                                                  book={props.book}
                                                  media={media}
                                                  index={mIndex}
                                                  parent={"paragraph"}
                                                  parentId={paragraph._id}
                                                  setMediaList={
                                                    props.setMediaList
                                                  }
                                                  mediaList={props.mediaList}
                                                />
                                              )
                                            )}
                                          </>
                                        )}
                                        {paragraph.image &&
                                        paragraph.image.link ? (
                                          <div className="p-media">
                                            <img
                                              src={paragraph.image.link}
                                              alt=""
                                            />
                                            <span>
                                              {paragraph.image.description}
                                            </span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>
                                    {props.book.activities.findIndex(
                                      (e) =>
                                        e.paragraphs.includes(paragraph._id) &&
                                        (e.paragraphs.length === 1 ||
                                          [...e.paragraphs]
                                            .sort((a, b) => a - b)
                                            .indexOf(paragraph._id) === 0)
                                    ) > -1 && (
                                      <img
                                        src={dimond}
                                        alt="diamond"
                                        className="cursor"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          props.setHighlightedSections([]);
                                          props.setGreyedPharagraphs([]);
                                          props.setGreyedItem("");
                                          props.setHighlightedIndexes([]);
                                          props.setDraggedOver(null);

                                          if (
                                            props.highlightedParagraph ===
                                            paragraph._id
                                          ) {
                                            props.setHighlightedParagraph(null);
                                            props.setGreyedItem("");
                                            props.setActivities(
                                              props.book.activities
                                            );
                                          } else {
                                            props.setHighlightedParagraph(
                                              paragraph._id
                                            );
                                            props.setGreyedPharagraphs(
                                              props.book.activities
                                                .filter((e) =>
                                                  e.paragraphs.includes(
                                                    paragraph._id
                                                  )
                                                )
                                                .flatMap(
                                                  (obj) => obj.paragraphs
                                                )
                                            );
                                            props.setActivities(
                                              props.book.activities.filter(
                                                (e) =>
                                                  e.paragraphs.includes(
                                                    paragraph._id
                                                  )
                                              )
                                            );
                                          }
                                        }}
                                        style={{
                                          alignSelf: "flex-start"
                                          // paddingRight: '10px',
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                                {props.draggedOverElement === paragraph._id &&
                                  (props.draggedType === "paragraph" ||
                                    props.draggedType === "image" ||
                                    props.draggedType === "audio" ||
                                    props.draggedType === "video" ||
                                    props.draggedType === "small_header") && (
                                    <div // className="dragged_indicator"
                                      style={{
                                        height: 0
                                      }}
                                      id="dragged_indicator"></div>
                                  )}
                                <div
                                  className={
                                    props.draggedOverElement ===
                                      paragraph._id &&
                                    (props.draggedType === "paragraph" ||
                                      props.draggedType === "image" ||
                                      props.draggedType === "audio" ||
                                      props.draggedType === "video" ||
                                      props.draggedType === "small_header")
                                      ? "dragged_indicator"
                                      : "dragged_indicator_transparent"
                                  }
                                  id="indicator"></div>
                              </div>
                            )}
                          </>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
            {props.draggedOverElement === props.section._id &&
              props.draggedType === "section" && (
                <div // className="dragged_indicator"
                  style={{
                    height: 0
                  }}
                  id="dragged_indicator"></div>
              )}
            <div
              className={
                props.draggedOverElement === props.section._id &&
                props.draggedType === "section"
                  ? "dragged_indicator"
                  : "dragged_indicator_transparent"
              }
              id="indicator"></div>
          </div>
        </div>
      )}
    </Draggable>
  );
});
export default Section;
